<template>
  <div class="box" @click="onGoPro">
    <!-- <div class="title">{{ title }}</div> -->
    <!-- <div class="desc">{{ desc }}</div> -->
    <el-image style="width: 100%; height: 100%" :src="img" fit="contain"></el-image>
  </div>
</template>

<script>
export default {
  name: '',

  mixins: [],

  components: {},

  props: {
    title: String,
    desc: String,
    img: String,
    url: String,
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    onGoPro() {
      this.$router.push(this.url)
    },
  },
}
</script>

<style lang="less" scoped>
.box {
  box-shadow: 1px 0 0 0 #e8e8e8, 0 1px 0 0 #e8e8e8, 1px 1px 0 0 #e8e8e8, 1px 0 0 0 #e8e8e8 inset,
    0 1px 0 0 #e8e8e8 inset;
  background: rgba(0, 0, 0, 0.7);
  margin-bottom: 20px;
  text-align: center;
  border-radius: 8px;
  font-size: 0;
  overflow: hidden;

  .title {
    font-size: 20px;
    padding: 25px 5px 20px;
    font-weight: normal;
  }

  .desc {
    color: #6e6e6e;
    padding: 0px 5px;
    line-height: 1.2;
    margin-bottom: 0;
    font-size: 14px;
  }
}

.box:hover {
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}
</style>
